// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0683bb30","239":"6f641931","453":"a29adc35","455":"12d9d3d3"}[chunkId] + ".chunk.js";
};